import React, { useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import HttpClient from '../../services/HttpClient'

const PUBLIC_PATHS = new Set([
  '/proximamente',
  '/entrar',
  '/registro',
  '/auth/login',
  '/auth/register',
  '/user/login',
])

export default function ComingSoonGate({ user, children }) {
  const location = useLocation()
  const [enabled, setEnabled] = useState(null)

  useEffect(() => {
    let cancelled = false

    const load = async () => {
      try {
        const res = await HttpClient().get('/api/v1/public/settings')
        if (!cancelled) {
          setEnabled(!!res.data?.coming_soon_enabled)
        }
      } catch (_error) {
        if (!cancelled) {
          setEnabled(false)
        }
      }
    }

    load()
    return () => {
      cancelled = true
    }
  }, [])

  if (enabled === null) {
    return <div>Loading...</div>
  }

  if (!enabled || user?.userId) {
    return children
  }

  const pathname = location.pathname
  const isPublicPath = PUBLIC_PATHS.has(pathname)

  if (pathname === '/') {
    return <Navigate to="/proximamente" replace />
  }

  if (!isPublicPath) {
    return <Navigate to="/proximamente" replace state={{ from: pathname }} />
  }

  return children
}
